import styled from "@emotion/styled";
import { CSSProperties } from "react";

const AnimatedDiv = styled.div`
  position: absolute;

  &.not-animated {
    left: 0vw;
  }
  &.animated {
    animation-name: slide;
    left: 100vw;
  }

  @keyframes slide {
    from {
      animation-timing-function: ease-in;
      left: 100vw;
    }
    20% {
      animation-timing-function: linear;
      left: 0vw;
    }
    90% {
      animation-timing-function: linear;
      left: -4vw;
    }
    to {
      animation-timing-function: linear;
      left: -100vw;
    }
  }
`;

export const XSlidingDiv = ({
  children,
  style,
  animated = true,
  durationInMs,
}: {
  children: React.ReactNode;
  style?: CSSProperties;
  animated?: boolean;
  durationInMs: number;
}) => {
  return (
    <AnimatedDiv
      className={animated ? "animated" : "not-animated"}
      style={{ animationDuration: `${durationInMs}ms`, ...style }}
    >
      {children}
    </AnimatedDiv>
  );
};
